import { TGlobalState } from '@types';

export const initiativeReportReducerSelector = (state: TGlobalState) => state.initiativeReport
export const initiativeReportsSelector = (state: TGlobalState) => state.initiativeReport.initiativeReports
